import { ReactNode } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { StepActions, StepContent } from '../ReauthenticationDialog.style'

interface LoadingStepProps {
  closeButton: ReactNode
}

const LoadingStep = ({ closeButton }: LoadingStepProps) => (
  <>
    <StepContent>
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    </StepContent>
    <StepActions disableSpacing>{closeButton}</StepActions>
  </>
)

export default LoadingStep
